import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { POLLING_INTERVAL_MS } from "../../constants/polling-constants";
import { queryKeys } from "../../lib/queryKeys";
import {
  getConversationList,
  getConversationMessageList,
} from "../../services";

export type ConversationListParams = {
  status?: string;
  topic_id?: string;
  provider_npi?: string;
  query_id?: string;
  limit?: number;
  page?: number;
  search?: string;
};

export const useConversationList = (
  params: ConversationListParams,
  options?: { enabled?: boolean; polling?: boolean }
) => {
  const enabled = options?.enabled ?? true;
  const polling = options?.polling ?? false;

  return useQuery({
    queryKey: queryKeys.conversationList(params),
    queryFn: () => getConversationList({ params }),
    enabled,
    placeholderData: keepPreviousData,
    refetchInterval: polling ? POLLING_INTERVAL_MS : false,
  });
};

export const useConversationMessages = (
  params: Record<string, unknown>,
  options?: { enabled?: boolean; polling?: boolean }
) => {
  const enabled = options?.enabled ?? true;
  const polling = options?.polling ?? false;

  return useQuery({
    queryKey: queryKeys.conversationMessages(params),
    queryFn: () => getConversationMessageList({ params }),
    enabled,
    staleTime: 0,
    refetchInterval: polling ? POLLING_INTERVAL_MS : false,
  });
};
